import React from 'react';
import { getTrackColorByStateAndDifficulty } from "../../helpers/map";
import { tracksWidth } from "../../config/defaults";
import { TRACK_DIFFICULTY_BLUE } from "../../config/constants";

const Connector11CBlack11BBlack = ({ state, workState }) => (
	<g id="Track-11C-black-connector" transform="translate(2194.000000, 456.000000)">
		<line
			x1="51.0650924" y1="214.892044" x2="0" y2="394"
			stroke={getTrackColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_BLUE)}
			strokeWidth={tracksWidth}
			strokeLinecap="round"
		/>
	</g>
);

export default Connector11CBlack11BBlack;
